export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export function userRegisterRequest(userBody) {
    return {
        type: USER_REGISTER_REQUEST,
        userBody
    }
}

export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export function userRegisterSuccess(userId) {
    return {
        type: USER_REGISTER_SUCCESS,
        userId
    }
}

export const USER_REGISTER_ERROR = 'USER_REGISTER_ERROR'
export function userRegisterError() {
    return {
        type: USER_REGISTER_ERROR
    }
}

export const CUSTOMER_REGISTER_REQUEST = 'CUSTOMER_REGISTER_REQUEST'
export function customerRegisterRequest(customerBody) {
    return {
        type: CUSTOMER_REGISTER_REQUEST,
        customerBody
    }
}

export const CUSTOMER_REGISTER_SUCCESS = 'CUSTOMER_REGISTER_SUCCESS'
export function customerRegisterSuccess(customerId) {
    return {
        type: CUSTOMER_REGISTER_SUCCESS,
        customerId
    }
}

export const CUSTOMER_REGISTER_ERROR = 'CUSTOMER_REGISTER_ERROR'
export function customerRegisterError() {
    return {
        type: CUSTOMER_REGISTER_ERROR
    }
}
